export const SCHEDULE_OF_INVESTMENTS_SPREADSHEET_HEADER_TITLE = 'SCHEDULE_OF_INVESTMENTS_SPREADSHEET_HEADER_TITLE';
export const SCHEDULE_OF_INVESTMENTS_SPREADSHEET_TOTAL = 'SCHEDULE_OF_INVESTMENTS_SPREADSHEET_TOTAL';
